import { AxiosInstance } from "axios";
import { createContext } from "react";

export const Apicontext = createContext<AxiosInstance | null>(null);

